/* eslint-disable react/prop-types */
import * as React from 'react';
import {
  createStackNavigator,
  CardStyleInterpolators,
} from '@react-navigation/stack';
import { useSafeAreaInsets } from 'react-native-safe-area-context';
import { isWeb, isMobileWeb } from '@global/screens';
import { setTitleHeader, setDefaultStackOption } from '@global/helpers';

import HamburgerButton from '@components/navbar/HamburgerButton';
import NotificationSettingButton from '@components/navbar/NotificationSettingButton';
import BackButton from '@components/navbar/BackButton';

import CustomerScreen from '@/screens/customer/CustomerScreen';
import CustomerDetailScreen from '@/screens/customer/CustomerDetailScreen';
const Stack = createStackNavigator();

// eslint-disable-next-line react/prop-types
const CustomerNavigator = ({ navigation }) => {
  const insets = useSafeAreaInsets();

  return (
    <Stack.Navigator
      initialRouteName="CustomerScreen"
      screenOptions={(props) => ({
        headerLeft: () => <HamburgerButton {...props} />,
        headerRight: () => <NotificationSettingButton {...props} />,
        ...setDefaultStackOption(insets, CardStyleInterpolators),
      })}>
      <Stack.Screen
        name="CustomerScreen"
        component={CustomerScreen}
        options={(props) => ({
          title: setTitleHeader('Customer'),
          hideScroll: true,
        })}
      />
      <Stack.Screen
        name="CustomerDetailScreen"
        component={CustomerDetailScreen}
        options={(props) => {
          const route = props.route;
          const isSkpExternalDetailScreen =
            props.route.params?.prev_page &&
            props.route.params.prev_page === 'skp-external'
              ? true
              : false;
          let title = 'Detail Customer';
          if (route.params && route.params.name && !(isWeb && !isMobileWeb)) {
            title = route.params.name;
          }
          return {
            title: setTitleHeader(title),
            headerLeft: () => (
              <BackButton
                {...props}
                // Always navigate() (pop) — never replace() — so returning to the
                // list preserves the migrated CustomerScreen instance (scroll +
                // filter via openChild) instead of remounting a duplicate.
                isJump={true}
                customBack={{
                  screen: isSkpExternalDetailScreen
                    ? 'SkpExternalNavigator'
                    : 'CustomerScreen',
                }}
              />
            ),
          };
        }}
      />
    </Stack.Navigator>
  );
};

export default CustomerNavigator;
